import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted [animation-duration:1.5s]", className)}
      {...props}
    />
  )
}

export { Skeleton }
